export default __webpack_public_path__ + "static/media/subject-english.84eb97b5.webp";